























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass } from '@/http';
import { calendarPanel,logoutPanel } from "@/components";
import dayjs from 'dayjs';
import classManage from "./classManage.vue"
import { Toast,Dialog } from 'vant';
const { userAgent } = navigator;
  const isAndroid =
    userAgent.indexOf("Android") > -1 ||
    userAgent.indexOf("android") > -1 ||
    userAgent.indexOf("Adr") > -1; // android终端
@Component({ 
    components: {
        calendarPanel,classManage,logoutPanel
    },
})
export default class product extends Vue {
   
    public $refs: {
        barcode:HTMLFormElement;
    };

    /**分类列表 */
    classList=[]

    /**查询项 */
    searchValue={
        goodsClassId:"",
        isShelves:true,
        start:"",
        end:"",
        name:"",
        timeSort:0,
        sort:null,
        stockSort:null,
        skip:0,
        count:32,
    }
    /**状态下拉 */
    showStatusPopover = false;
    statusOptions=[
        {
            label:"全部状态",
            value:null,
        },
        {
            label:"上架中",
            value:true,
        },
        {
            label:"已下架",
            value:false,
        },
    ]

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType=1;

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    /**分类管理弹窗 */
    showClass=false;

    Loop=null;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    deleteId="";
    isDeleting = false;
    /**滑动定位 */
    classScrollVal = 0;
    listScrollVal = 0;
    tableScrollVal = 0;
    isScan = false;


    @Watch('searchValue.name')
    async nameChange(val){
        this.getList();
    }

    created() {
        
    }

    async activated(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        this.searchValue.goodsClassId = "";
        // await this.getClassList();
        // await this.getList();
        if(this.$refs['class_list']){
            this.$refs['class_list'].scrollTop=this.classScrollVal;
        }
        if(this.$refs['list_box']){
            this.$refs['list_box'].scrollTop=this.listScrollVal;
        }
        if(this.$refs['table_box']){
            this.$refs['table_box'].scrollTop=this.tableScrollVal;
        }

        this.getInputFocus()
        document.addEventListener('click',this.chargeInputFocus)
    }
    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        await this.getClassList();
        await this.getList();

        this.getInputFocus()

        document.addEventListener('click',this.chargeInputFocus)
        
    }

    classScroll(e){
        this.classScrollVal = e.target.scrollTop?e.target.scrollTop:0;
    }
    listScroll(e){
        this.listScrollVal = e.target.scrollTop?e.target.scrollTop:0;
    }
    tableScroll(e){
        this.tableScrollVal = e.target.scrollTop?e.target.scrollTop:0;
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
            this.getInputFocus()
        }
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        if(this.isFocus){
            this.searchValue.name = event.target.value 
        }else{

            if (event.key === 'Enter' || event.keyCode == 13) {
                console.log('查询123',this.scanCodes)
                let code = this.scanCodes?this.scanCodes: event.target.value
                await this.scanInput(code);
    
                this.scanCodes = ''
            return
            }
        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    clearListen(){
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    addListen(){
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.addEventListener('click',this.chargeInputFocus)
    }

    handleEnter(){
        setTimeout(()=>{
            this.getList();
        },200)
    }
    isFocus = false
    getFocus(){
        this.isFocus = true
    }
    inputBlur(){
        this.isFocus = false
        document.addEventListener('click',this.chargeInputFocus)
    }
    
    async scanInput(val){
        // let res = await TbGoods.GetTbGoodsByBarCode({barCode:val});
        // if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
        //     this.searchValue.name = res.barCode?res.barCode:'';
        // }else{
        //     this.searchValue.name = ''
        // }
        let resnew = await TbGoods.GetTbGoodsByBarCodeV3({barCode:val});
        this.list = [];
        this.list = resnew.items;
        this.total = 0;
        this.totalStock = 0;
        this.isScan = true;
        this.finished = true;
    }

    /**上架状态 */
    get getShelveStatus(){
        let str = ""
        switch (this.searchValue.isShelves) {
            case null:
                str="全部状态"
                break;
            case true:
                str="上架中"
                break;
            case false:
                str="已下架"
                break;
        
            default:
                break;
        }
        return str;
    }

    /**获取分类列表 */
    async getClassList(){
        let res = await TbGoodsClass.GetAllGoodsClassList({
            needGoodsCount:true
        }) 
        this.classList = res.map(v=>{
            return{
                ...v,
                isShowChild:false
            }
        });
    }
    /**选择全部分类 */
    async chooseAllClass(){
        this.classList = this.classList.map(v=>{
            return {
                ...v,
                isShowChild:false
            }
        })
        this.searchValue.goodsClassId="";
        // await this.getList();
        this.refreshing = true
        this.onRefresh()
    }
    /**选择一级分类 */
    async chooseClass(item,index){
        /**只有一级 */
        if(item.items.length==0){
            this.classList = this.classList.map(v=>{
                return {
                    ...v,
                    isShowChild:false
                }
            })
            this.searchValue.goodsClassId = item.id;
            await this.getList();
        }else{
            let checked = !item.isShowChild;
            this.classList = this.classList.map(v=>{
                return {
                    ...v,
                    isShowChild:false
                }
            })
            this.$set(this.classList[index],'isShowChild',checked);
            this.searchValue.goodsClassId = item.id;
            await this.getList();
        }
    }
    /**选择二级分类 */
    async chooseClassChid(item,index,index2){
        this.searchValue.goodsClassId = item.id;
        await this.getList();
    }
    /**获取分类选中状态 */
    getActiveStatus(item){
        let str = '';
        if(item.items.length==0){
            if(this.searchValue.goodsClassId==item.id){
                str = "isActive11"
            }
        }else{
            if(item.items.findIndex(v=>v.id==this.searchValue.goodsClassId)>-1||this.searchValue.goodsClassId==item.id){
                str = "isActive2"
            }
        }
        return str;
    }
    /**选择状态 */
    async changeStatusXL(item,index){
        this.searchValue.isShelves = item.value;
        this.showStatusPopover = false;
        await this.getList();
    }
    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
        this.searchValue.start = dayjs(start).format("YYYY-MM-DD") + " " + "00:00:00";
        this.searchValue.end = dayjs(end).format("YYYY-MM-DD") + " " + "23:59:59";
        this.pickerShow = false;
        this.getList();
    }
    closeTime(){
        this.pickerShow = false;
    }
    /**列表形态转变 */
    changeShowType(val){
        this.showType = val;
    }
    /**下拉刷新 */
    async onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.list = [];
      this.searchValue.skip=0;
      this.searchValue.count=32;
      this.total = 0;
      this.currentPage = 1;
      await this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
        console.log('loadMore');
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbGoods.GetTbGoodsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }))

            this.$nextTick(async()=>{
                this.list = this.searchValue.skip==0? res.items.map(v=>{
                    return{
                        ...v,
                        sellingPrice:v.sellingPrice.toFixed(2),
                        discountPrice:v.discountPrice.toFixed(2),
                        createTime:dayjs(v.createTime).format("YYYY-MM-DD")
                    }
                }):this.list.concat(res.items.map(v=>{
                    return{
                        ...v,
                        sellingPrice:v.sellingPrice.toFixed(2),
                        discountPrice:v.discountPrice.toFixed(2),
                        createTime:dayjs(v.createTime).format("YYYY-MM-DD")
                    }
                }));
                this.total  = res.totalCount;
                this.currentPage++;
                this.searchValue.skip = (this.currentPage - 1) * s;
                this.loading = false;
                await this.getTotal();
                if (this.list.length >= this.total) {
                this.finished = true;
                
                }
            })
            
    }
    /**获取商品列表 */
    async getList(){
        // this.onRefresh();
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=32;
        this.total = 0;
        this.currentPage = 1;

        let res = await TbGoods.GetTbGoodsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }))

            this.list =  res.items.map(v=>{
                return{
                    ...v,
                    sellingPrice:v.sellingPrice.toFixed(2),
                    discountPrice:v.discountPrice.toFixed(2),
                    createTime:dayjs(v.createTime).format("YYYY-MM-DD")
                }
            })
            this.total  = res.totalCount;
            this.isScan = false;
            await this.getTotal();
            this.finished = false;
          
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            goodsClassId:"",
            isShelves:true,
            start:"",
            end:"",
            name:"",
            timeSort:0,
            sort:null,
            stockSort:null,
            skip:0,
            count:32,
        }
        this.classScrollVal = 0;
        this.listScrollVal = 0;
        this.tableScrollVal = 0;
        this.startDate = "";
        this.endDate = "";
        this.showStatusPopover = false;
        this.getList();
    }
    async init(){
        await this.getClassList();
        await this.onRefresh();
    }
    /**获取总计 */
    async getTotal(){
        let res= await TbGoods.GetTbGoodsTotal({
            name:this.searchValue.name,
            goodsClassId:this.searchValue.goodsClassId,
            isShelves:this.searchValue.isShelves,
            shopId:this.userInfo.shopId,
            start:this.searchValue.start,
            end:this.searchValue.end,
        })
        this.totalStock = res.totalStock;
    }
    /**排序 */
    async sortFun(type){
        switch (type) {
            case 1:
                this.searchValue.stockSort=null;
                this.searchValue.timeSort=null;
                this.searchValue.sort = this.searchValue.sort!=null?this.searchValue.sort==2?3:null :2
                break;
            case 2:
                this.searchValue.stockSort=null;
                this.searchValue.timeSort=null;
                this.searchValue.sort = this.searchValue.sort!=null?this.searchValue.sort==0?1:null :0
                break;
            case 3:
                this.searchValue.sort=null;
                this.searchValue.timeSort=null;
                this.searchValue.stockSort = this.searchValue.stockSort!=null?this.searchValue.stockSort==0?1:null :0
                break;
            case 4:
                this.searchValue.stockSort=null;
                this.searchValue.sort=null;
                this.searchValue.timeSort = this.searchValue.timeSort!=null?this.searchValue.timeSort==0?1:null :0
                break;
        
            default:
                break;
        }
        await this.getList();
    }
    async closeClassManage(){
        this.showClass = false;
        await this.getClassList();
        await this.getList();
    }
    showClassManage(){
        this.showClass = true;
    }
    addProduct(){
        if(!this.hasAuth('102')){
            Toast("暂无操作权限，请联系管理员")
            return;
        }
        this.$router.push("/pad/product/addProduct")
    }
    clickCount:number = 0;
    timer:any = null
    viewDetail(item){
        this.clickCount++
        this.timer = setTimeout( async ()=>{
            if(this.clickCount == 1){
                this.clickCount = 0
                this.$router.push("/pad/product/viewProduct?id="+item.id);
            }else if(this.clickCount>1){
                this.clickCount = 0
                await this.touchstart(item)
                setTimeout( async ()=>{
                    await this.touchend()
                },200)
            }
        },300)
    }
    async deleteFun(){
        if(this.isDeleting) return;
        this.isDeleting = true;
        try {
            let res = await TbGoods.DeleteTbGoods(this.deleteId);
            this.isDeleting = false;
            Toast("删除成功");
            await this.getList();
        } catch (error) {
            this.isDeleting = false;
        }
    }
    /**提示弹窗 */
    async tipConfirm(){
        if(this.tipType==1){
            this.deleteFun()
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    touchstart(item){
        if(!this.hasAuth('104'))return;
        // if(!this.isManage)return;
        console.log('touchstart');
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            
            this.tipTitle = "删除商品提醒";
            this.tipText = `删除后，您将无法查看该商品的任何数据信息。确定删除该商品吗？`;
            this.btnNums=2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 1;
            this.deleteId = item.id;
            this.tipShow = true;
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }
    touchend(){
        // if(!this.isManage)return;
        console.log('touchend');
        clearInterval(this.Loop);
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson']?this.userInfo['authorityJson'].split(','):[];
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/product/components/info.vue